"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UILockedSelectFeatures = _interopRequireDefault(require("ui-addon-upgrades/decorators/UILockedSelectFeatures"));

var _UILockBadge = _interopRequireDefault(require("UIComponents/badge/UILockBadge"));

var _configUtils = require("AudienceTargetingUIComponents/utils/configUtils");

var _Filters = require("AudienceTargetingUIComponents/constants/Filters");

var FilterSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterSelect, _PureComponent);
  (0, _createClass2.default)(FilterSelect, null, [{
    key: "propTypes",
    get: function get() {
      return {
        hasScope: _react.PropTypes.bool.isRequired,
        labelConfig: _react.PropTypes.object,
        onChange: _react.PropTypes.func,
        options: _react.PropTypes.object,
        upgradeConfig: _react.PropTypes.object.isRequired,
        value: _react.PropTypes.string
      };
    }
  }]);

  function FilterSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterSelect).call(this, props));
    _this.textKey = _this.textKey.bind((0, _assertThisInitialized2.default)(_this));
    _this.isLocked = _this.isLocked.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FilterSelect, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "textKey",
    value: function textKey(levels) {
      var labelConfig = this.props.labelConfig;
      var custom;

      if (labelConfig[levels[0]]) {
        custom = (0, _configUtils.searchConfig)(labelConfig, levels);
      }

      return custom || _I18n.default.text(this.langKey("" + levels.join('.')));
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      var options = this.props.options;
      return Object.keys(options).map(function (i) {
        return (0, _extends2.default)({
          id: i
        }, options[i]);
      });
    }
  }, {
    key: "getFilterGroups",
    value: function getFilterGroups() {
      var options = this.props.options;
      var groups = Object.keys(options).map(function (i) {
        return options[i].group;
      });
      var filterGroups = (0, _toConsumableArray2.default)(new _immutable.Set(groups));
      return filterGroups[0] !== 'contacts' ? filterGroups.reverse() : filterGroups;
    }
  }, {
    key: "getGroup",
    value: function getGroup() {
      var value = this.props.value;
      var filters = this.getFilters();
      var filterOption = filters.find(function (i) {
        return i.id === value;
      });
      var group = filterOption && filterOption.group;
      return group;
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this2 = this;

      var hasScope = this.props.hasScope;
      var groups = this.getFilterGroups();
      var filters = this.getFilters();
      return groups.map(function (group) {
        return {
          text: _this2.textKey(['group', group]),
          badge: !hasScope && group === 'allVisitors' ? _react.default.createElement(_UILockBadge.default, null) : null,
          options: filters.filter(function (filter) {
            return filter.group === group;
          }).map(function (filter) {
            return {
              text: _this2.textKey(['filter', filter.key]),
              value: filter.id,
              locked: _this2.isLocked(filter.id)
            };
          })
        };
      });
    }
  }, {
    key: "getValueText",
    value: function getValueText() {
      var _this$props = this.props,
          options = _this$props.options,
          value = _this$props.value;
      return this.textKey(['filter', options[value].key]);
    }
  }, {
    key: "isLocked",
    value: function isLocked(value) {
      var hasScope = this.props.hasScope;
      return value && !hasScope && _Filters.FILTERS[value].group === _Filters.FILTER_GROUPS.ALLVISITORS;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          value = _this$props2.value,
          upgradeConfig = _this$props2.upgradeConfig;
      return _react.default.createElement("div", null, _react.default.createElement(_UILockedSelectFeatures.default, {
        modalKey: upgradeConfig && upgradeConfig.modalKey,
        upgradeData: {
          app: upgradeConfig && upgradeConfig.app,
          screen: upgradeConfig && upgradeConfig.screen,
          upgradeProduct: 'marketing-pro',
          uniqueId: 'audience-targeting-ui-components'
        }
      }, _react.default.createElement(_UISelect.default, {
        placeholder: this.textKey(['filterPlaceholder']),
        className: "targeting-option__select-rule rule",
        itemComponent: function itemComponent(_ref) {
          var children = _ref.children;
          return _react.default.createElement("span", {
            className: "filter__select__item"
          }, children);
        },
        value: value,
        onChange: onChange,
        options: this.getOptions(),
        searchable: true
      })));
    }
  }]);
  return FilterSelect;
}(_react.PureComponent);

exports.default = FilterSelect;
module.exports = exports.default;